document.addEventListener('DOMContentLoaded', () => {
  const wrapper = document.querySelector('.wrapper');
  if (!wrapper) return;
  
  const texts = Array.from(wrapper.querySelectorAll('.text-slider-2 .text'));
  const prevBtn = wrapper.querySelector('#prev');
  const nextBtn = wrapper.querySelector('#next');
  const sliderEl = wrapper.querySelector('.image-slider');
  
  // 1) Swiper 初期化
  const swiper = new Swiper(sliderEl, {
    slidesPerView: 'auto',
    spaceBetween: 20,
    loop: true,
  });
  
  // 2) テキストを “インデックス同期” で切り替える関数
  function showTextAt(index) {
    texts.forEach((el, i) => {
      el.style.display = (i === index) ? 'block' : 'none';
    });
  }
  
  // 3) 初期表示は先頭だけ見せる
  showTextAt(0);
  
  // 4) ボタン連動（touch/swipe でも方向問わず slideChange で拾う）
  prevBtn.addEventListener('click', () => swiper.slidePrev());
  nextBtn.addEventListener('click', () => swiper.slideNext());
  
  // 5) スライド終了時に同期
  swiper.on('slideChangeTransitionEnd', () => {
    // realIndex は loop:true 時も正しいループ後のインデックスを返す
    showTextAt(swiper.realIndex);
  });
});
